import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ClientService } from './client.service';

export interface AccountUserWorkspaceRoleModel {
  userName: string | null;
  email: string;
  workspaceName: string;
  roleId: number;
  roleName: string;
}

@Injectable({ providedIn: 'root' })
export class AccountUserService {
  private readonly client = inject(ClientService);

  listByAccount(
    accountId: number,
  ): Observable<AccountUserWorkspaceRoleModel[]> {
    return this.client.get<AccountUserWorkspaceRoleModel[]>(
      `account/${accountId}/users`,
    );
  }
}
